import { Injectable } from '@angular/core';
import {
  BaseControl,
  Custom,
  SubForma,
  Textbox,
} from '@app/shared';


@Injectable()
export class MultipleRecordsFormService {

  constructor() { }

  /**
   * Retorna el formualrio para configurar opcion de multiples registros
   *
   * @param {SubForma} form
   * @param {*} templeteForm
   * @returns {BaseControl<any>[]}
   * @memberof MultipleRecordsFormService
   */
  getFormMultipleRecords(form: SubForma, templeteForm: any): BaseControl<any>[] {
    const messageHelpCbo = 'Seleccionar el campo por el cual se realizaran los múltiples registros';
    const messageHelpChk = 'Campo que permite controlar si los registros realizados se guardan en la tarea' +
                            ' o se almacenan en las maestras';
    const controls: BaseControl<any>[] = [
      new Custom({
        key: 'cboCampoMultiple',
        template: templeteForm,
        label: 'Campo múltiple:',
        placeholder: 'Seleccione el campo de múltiple',
        order: 1,
        value: form ? form.estilo ? form.estilo['campo_multiple'] : null : null,
        describe: messageHelpCbo
      }),
      new Textbox({
        key: 'chkRegistroTarea',
        type: 'checkbox',
        label: 'Registro en tarea',
        order: 2,
        describe: messageHelpChk,
        value: form ? form.estilo ? form.estilo['registro_tarea'] : null : null,
        condictions: [
          {
            campoDepende: 'cboCampoMultiple',
            siEs: 'Vacio',
            accion: 'Ocultar'
          }
        ]
      })
    ];

    return controls.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/creation-form/multiple-records/shared/multiple-records.form.service.ts